<template>
  <div class="physioData" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-radio-group v-model="type" @input="typeChange">
          <el-radio-button class="header_left_radio" label="1">开单</el-radio-button>
          <el-radio-button class="header_left_radio" label="2">执行</el-radio-button>
        </el-radio-group>
      </div>
      <div class="header_right">
        <DateSelect v-model="date" @change="dateChange"></DateSelect>
      </div>
    </div>

    <!-- 基础数据 -->
    <div class="card basic">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">{{ type === '1' ? '开单' : '执行' }}基础数据</div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
      </div>

      <div class="basic_content">
        <div class="basic_info">
          <div class="basic_status_list" :style="`grid-template-columns: ${statusMap.gridColumns}`">
            <template v-for="statusItem in statusMap.list">
              <div v-if="statusItem.type === 'option'" :class="{ status_list_item: true, active: statusItem.id === statusActive }" @click="statusOn(statusItem.id)">
                <div class="status_title">{{ statusItem.name }}</div>
                <div class="status_info">
                  <div class="status_info_left">
                    <div class="status_info_title">人数(人)</div>
                    <div class="status_info_num">{{ statusItem.peopleNum }}</div>
                  </div>
                  <div v-if="!statusItem.hideRight" class="status_info_line"></div>
                  <div v-if="!statusItem.hideRight" class="status_info_right">
                    <div class="status_info_title">{{ type === '1' ? '金额(元)' : '预估项目数(个)' }}</div>
                    <div class="status_info_num">{{ type === '1' ? statusItem.price : statusItem.estimateProductNum }}</div>
                  </div>
                </div>
                <div v-if="statusItem.id === 1 && ![0, '0', '', null, undefined].includes(statusItem.waitPrice)" class="status_info_tips">含<span class="status_info_tips_num">{{ statusItem.waitPrice }}</span>待收</div>
              </div>

              <div v-if="statusItem.type === 'option_3'" :class="{ status_list_item: true, active: statusItem.id === statusActive }" @click="statusOn(statusItem.id)">
                <div class="status_title">{{ statusItem.name }}</div>
                <div class="status_info column_3">
                  <div class="status_info_left">
                    <div class="status_info_title">人数(人)</div>
                    <div class="status_info_num">{{ statusItem.peopleNum }}</div>
                  </div>
                  <div class="status_info_line"></div>
                  <div class="status_info_right">
                    <div class="status_info_title">执行项目数(个)</div>
                    <div class="status_info_num">{{ statusItem.executeProductNum }}</div>
                  </div>
                  <div class="status_info_line"></div>
                  <div class="status_info_right">
                    <div class="status_info_title">金额合计(元)</div>
                    <div class="status_info_num">{{ statusItem.price }}</div>
                  </div>
                </div>
                <div v-if="![0, '0', '', null, undefined].includes(statusItem.waitPrice)" class="status_info_tips">含<span class="status_info_tips_num">{{ statusItem.waitPrice }}</span>待收</div>
              </div>

              <div v-if="statusItem.type === 'line'" class="status_list_line"></div>
            </template>
          </div>

          <div class="basic_table_header">
            <div v-if="type === '1'" class="basic_table_title">数据列表</div>
            <div v-if="type === '2' && statusActive === 1" class="basic_table_count">
              有项目预约<span class="basic_table_count_num">{{ executeMap.reservationStatusStatistics.hasOrderCount }}</span>单，
              无项目预约<span class="basic_table_count_num">{{ executeMap.reservationStatusStatistics.notHasOrderCount }}</span>单
            </div>
            <div v-if="type === '2' && statusActive === 2" class="basic_table_count">
              有项目预约<span class="basic_table_count_num">{{ executeMap.notExecuteStatusStatistics.hasOrderCount }}</span>单，
              无项目预约<span class="basic_table_count_num">{{ executeMap.notExecuteStatusStatistics.notHasOrderCount }}</span>单
            </div>
          </div>

          <div class="basic_table_section">
            <el-table v-if="type === '1'" :key="`billing_${statusActive}`" class="custom_table" :data="basicMap.list" max-height="350">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="patientName" label="患者" min-width="70"></el-table-column>
              <el-table-column prop="sex" label="性别" min-width="50">
                <template slot-scope="scope">
                  <span v-if="scope.row.sex === '0'">男</span>
                  <span v-if="scope.row.sex === '1'">女</span>
                  <span v-if="scope.row.sex === '2'">未知</span>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" min-width="60">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}岁</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="手机号码" min-width="110"></el-table-column>
              <el-table-column prop="doctorVisit" label="患者类型" min-width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.doctorVisit === '0'">新诊</span>
                  <span v-if="scope.row.doctorVisit === '1'">回诊</span>
                </template>
              </el-table-column>
              <el-table-column prop="diagnosis" label="诊断" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="physioNames" label="开单项目" min-width="200" show-overflow-tooltip></el-table-column>
              <el-table-column prop="finishTime" label="完诊时间" min-width="160">
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.finishTime) ? '-' : `${new Date(scope.row.finishTime).Format('yyyy-MM-dd hh:mm:ss')}` }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="originalPhysioAmount" label="开单金额" align="right" min-width="90"></el-table-column>
              <el-table-column prop="totalAmount" label="实收" align="right" min-width="90"></el-table-column>
              <el-table-column label="状态" align="center" min-width="100">
                <template slot-scope="scope">
                  <div class="basic_table_center">
                    <div v-if="billingStatusMap[scope.row.status]" :class="`basic_table_tag ${billingStatusMap[scope.row.status].class}`">{{ billingStatusMap[scope.row.status].name }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-table v-if="type === '2'" :key="`execute_${statusActive}`" class="custom_table" :data="basicMap.list" max-height="350">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="patientName" label="患者" min-width="70"></el-table-column>
              <el-table-column prop="sex" label="性别" min-width="50">
                <template slot-scope="scope">
                  <span v-if="scope.row.sex === '0'">男</span>
                  <span v-if="scope.row.sex === '1'">女</span>
                  <span v-if="scope.row.sex === '2'">未知</span>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" min-width="60">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}岁</span>
                </template>
              </el-table-column>
              <el-table-column prop="phone" label="手机号码" min-width="110"></el-table-column>
              <el-table-column prop="diagnosis" label="诊断" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column v-if="[1, 2].includes(statusActive)" prop="physioName" label="预约项目" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.physioName) ? '-' : scope.row.physioName }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="[1, 2].includes(statusActive)" prop="reservationStartTime" label="预约时间" min-width="180">
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.reservationStartTime) ? '-' : `${new Date(scope.row.reservationStartTime).Format('yyyy-MM-dd hh:mm')}-${new Date(scope.row.reservationEndTime).Format('hh:mm')}` }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="[1].includes(statusActive)" prop="reservation" label="预约单状态" align="center" min-width="120">
                <template slot-scope="scope">
                  <div class="basic_table_center">
                    <div v-if="reservationStatusMap[scope.row.reservation]" :class="`basic_table_tag ${reservationStatusMap[scope.row.reservation].class}`">{{ reservationStatusMap[scope.row.reservation].name }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="[1, 3].includes(statusActive)" prop="executePhysioName" label="执行项目" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.executePhysioName) ? '-' : scope.row.executePhysioName }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="[3].includes(statusActive)" prop="executeStartTime" label="执行日期" min-width="160">
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.executeStartTime) ? '-' : `${new Date(scope.row.executeStartTime).Format('yyyy-MM-dd hh:mm:ss')}` }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="[1, 3].includes(statusActive)" prop="amount" label="执行金额(元)" align="right" min-width="120">
                <template slot-scope="scope">
                  <span>{{ [null, undefined].includes(scope.row.amount) ? '-' : scope.row.amount }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="basic_table_pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="basicMap.pageNo"
              :page-size="basicMap.pageSize"
              :total="basicMap.total"
              @current-change="basicTablePageNoChange">
            </el-pagination>
          </div>
        </div>

        <div class="product_ranking">
          <el-table class="ranking_table" :data="productRankingList" height="560">
            <el-table-column type="index" label="排名" align="center" width="50">
              <template slot-scope="scope">
                <div :class="{ ranking_table_index: true, ranking_table_index_1: scope.$index + 1 === 1, ranking_table_index_2: scope.$index + 1 === 2, ranking_table_index_3: scope.$index + 1 === 3 }">{{ scope.$index + 1 }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="physioName" label="分类名称" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <div :class="{ ranking_table_name: true, none: [null, undefined, ''].includes(scope.row.physioName) }">{{ scope.row.physioName || '未维护分类' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="患者数" align="center" min-width="70">
              <template slot-scope="scope">
                <div>{{ scope.row.count }}人</div>
              </template>
            </el-table-column>
            <el-table-column v-if="type === '1'" prop="orderCount" label="开单次数" align="center" min-width="80">
              <template slot-scope="scope">
                <div>{{ scope.row.orderCount }}次</div>
              </template>
            </el-table-column>
            <el-table-column v-if="type === '2'" prop="orderCount" label="执行次数" align="center" min-width="80">
              <template slot-scope="scope">
                <div>{{ scope.row.executeCount }}次</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    getPhysioBillingStatistics,
    getPhysioBillingList,
    getPhysioBillingRank,
    getPhysioExecuteStatistics,
    getPhysioExecuteList,
    getPhysioExecuteRank
  } from "@/api/doctorDataAnalysis"

  import DateSelect from './components/DateSelect.vue'

  export default {
    name: 'physioData',
    components: { DateSelect },
    filters: {
      dateFilter (value) {
        if (Array.isArray(value) && value.length === 2) {
          if (value[0] === value[1]) {
            const today = new Date().Format('yyyy-MM-dd')
            if (value[0] === today) {
              return `今天${new Date(today).Format('MM.dd')}`
            }

            let tomorrowDay = new Date()
            tomorrowDay.setDate(tomorrowDay.getDate() + 1)
            tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
            if (value[0] === tomorrowDay) {
              return `明天${new Date(tomorrowDay).Format('MM.dd')}`
            }

            let afterTomorrow = new Date()
            afterTomorrow.setDate(afterTomorrow.getDate() + 2)
            afterTomorrow = afterTomorrow.Format('yyyy-MM-dd')
            if (value[0] === afterTomorrow) {
              return `后天${new Date(afterTomorrow).Format('MM.dd')}`
            }

            let yesterdayDay = new Date()
            yesterdayDay.setDate(yesterdayDay.getDate() - 1)
            yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
            if (value[0] === yesterdayDay) {
              return `昨天${new Date(yesterdayDay).Format('MM.dd')}`
            }

            let format = new Date(value[0]).Format('yyyy') === new Date().Format('yyyy') ? 'MM.dd' : 'yyyy.MM.dd'
            return `${new Date(value[0]).Format(format)}`
          } else {
            return `${new Date(value[0]).Format('yyyy.MM.dd')} - ${new Date(value[1]).Format('yyyy.MM.dd')}`
          }
        }
        return ''
      }
    },
    props: {
      doctorId: {
        type: [Number, String],
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        reqNum: 0,
        deptId: '',
        doctorId: '',
        type: '1',
        date: [new Date().Format('yyyy-MM-dd'), new Date().Format('yyyy-MM-dd')],
        statusActive: 1,
        billingStatusMap: {
          1: {
            name: '已诊',
            class: 'table_tag_warning'
          },
          2: {
            name: '待收',
            class: 'table_tag_warning'
          },
          3: {
            name: '已收',
            class: 'table_tag_success'
          },
          4: {
            name: '已退',
            class: 'table_tag_info'
          },
          5: {
            name: '关闭',
            class: 'table_tag_info'
          }
        },
        reservationStatusMap: {
          1: {
            name: '已预约',
            class: 'table_tag_success'
          },
          2: {
            name: '已取消',
            class: 'table_tag_info'
          },
          3: {
            name: '已执行',
            class: 'table_tag_info'
          },
          4: {
            name: '已停诊',
            class: 'table_tag_warning'
          },
          5: {
            name: '已结束',
            class: 'table_tag_info'
          }
        },
        basicMap: {
          list: [],
          pageNo: 1,
          pageSize: 10,
          total: 0
        },
        productRankingList: [],
        billingMap: {
          diagnosedStatusStatistics: {
            count: 0,
            amount: 0,
            stayPayAmount: 0
          },
          notPayStatusStatistics: {
            count: 0,
            amount: 0,
            stayPayAmount: 0
          },
          payStatusStatistics: {
            count: 0,
            amount: 0,
            stayPayAmount: 0
          },
          refundStatusStatistics: {
            count: 0,
            amount: 0,
            stayPayAmount: 0
          },
          closeStatusStatistics: {
            count: 0,
            amount: 0,
            stayPayAmount: 0
          }
        },
        executeMap: {
          reservationStatusStatistics: {
            count: 0,
            itemCount: 0,
            hasOrderCount: 0,
            notHasOrderCount: 0
          },
          notExecuteStatusStatistics: {
            count: 0,
            itemCount: 0,
            hasOrderCount: 0,
            notHasOrderCount: 0
          },
          executedStatusStatistics: {
            count: 0,
            totalExecuteCount: 0,
            amount: 0
          }
        }
      }
    },
    computed: {
      statusMap () {
        let gridColumns = ''
        let list = []

        if (this.type === '1') {
          gridColumns = '1fr auto 1fr 1fr 1fr 1fr'
          list = [
            {
              id: 1,
              type: 'option',
              name: '理疗门诊量',
              peopleNum: this.billingMap.diagnosedStatusStatistics.count,
              price: this.billingMap.diagnosedStatusStatistics.amount,
              waitPrice: this.billingMap.diagnosedStatusStatistics.stayPayAmount
            },
            {
              id: -1,
              type: 'line'
            },
            {
              id: 2,
              type: 'option',
              name: '待收',
              peopleNum: this.billingMap.notPayStatusStatistics.count,
              price: this.billingMap.notPayStatusStatistics.amount,
              waitPrice: this.billingMap.notPayStatusStatistics.stayPayAmount
            },
            {
              id: 3,
              type: 'option',
              name: '已收',
              peopleNum: this.billingMap.payStatusStatistics.count,
              price: this.billingMap.payStatusStatistics.amount,
              waitPrice: this.billingMap.payStatusStatistics.stayPayAmount
            },
            {
              id: 4,
              type: 'option',
              name: '已退',
              peopleNum: this.billingMap.refundStatusStatistics.count,
              price: this.billingMap.refundStatusStatistics.amount,
              waitPrice: this.billingMap.refundStatusStatistics.stayPayAmount
            },
            {
              id: 5,
              type: 'option',
              name: '关闭',
              peopleNum: this.billingMap.closeStatusStatistics.count,
              price: this.billingMap.closeStatusStatistics.amount,
              waitPrice: this.billingMap.closeStatusStatistics.stayPayAmount
            }
          ]
        }

        if (this.type === '2') {
          gridColumns = '1fr auto 1fr 1.75fr'
          list = [
            {
              id: 1,
              type: 'option',
              name: '总预约量',
              peopleNum: this.executeMap.reservationStatusStatistics.count,
              price: 0,
              waitPrice: 0,
              estimateProductNum: this.executeMap.reservationStatusStatistics.itemCount
            },
            {
              id: -1,
              type: 'line'
            },
            {
              id: 2,
              type: 'option',
              name: '待执行',
              peopleNum: this.executeMap.notExecuteStatusStatistics.count,
              price: 0,
              waitPrice: 0,
              estimateProductNum: this.executeMap.notExecuteStatusStatistics.itemCount
            },
            {
              id: 3,
              type: 'option_3',
              name: '已执行',
              peopleNum: this.executeMap.executedStatusStatistics.count,
              price: this.executeMap.executedStatusStatistics.amount,
              waitPrice: 0,
              executeProductNum: this.executeMap.executedStatusStatistics.totalExecuteCount
            }
          ]
        }
        
        return {
          gridColumns: gridColumns,
          list: list
        }
      }
    },
    created () {
      this.deptId = sessionStorage.getItem('deptId')

      this.type = '1'
      this.statusActive = 1
      this.getBillingStatistics()
      this.getBillingList()
      this.getBillingRank()
    },
    methods: {
      afterRes () {
        this.reqNum--;
        if (this.reqNum <= 0) {
          this.loading = false
          this.reqNum = 0;
        }
      },
      typeChange (val) {
        this.statusActive = 1
        this.basicMap.list = []
        this.basicMap.pageNo = 1
        this.basicMap.total = 0
        this.productRankingList = []
        switch (val) {
          case '1':
            this.getBillingStatistics()
            this.getBillingList()
            this.getBillingRank()
            break
          case '2':
            this.getExecuteStatistics()
            this.getExecuteList()
            this.getExecuteRank()
            break
        }
      },
      dateChange () {
        this.basicMap.list = []
        this.basicMap.pageNo = 1
        this.basicMap.total = 0
        this.productRankingList = []
        switch (this.type) {
          case '1':
            this.getBillingStatistics()
            this.getBillingList()
            this.getBillingRank()
            break
          case '2':
            this.getExecuteStatistics()
            this.getExecuteList()
            this.getExecuteRank()
            break
        }
      },
      statusOn (id) {
        if (id && this.statusActive !== id) {
          this.statusActive = id
          this.basicMap.list = []
          this.basicMap.pageNo = 1
          this.basicMap.total = 0
          if (this.type === '1') {
            this.getBillingStatistics()
            this.getBillingList()
          } else {
            this.getExecuteStatistics()
            this.getExecuteList()
          }
        }
      },
      async getBillingStatistics () {
        this.loading = true
        this.reqNum++
        const res = await getPhysioBillingStatistics({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`
        })
        this.afterRes()
        if (res.code === 200) {
          this.billingMap.diagnosedStatusStatistics.count = res.data.diagnosedStatusStatistics.count || 0
          this.billingMap.diagnosedStatusStatistics.itemCount = res.data.diagnosedStatusStatistics.itemCount || 0
          this.billingMap.diagnosedStatusStatistics.amount = res.data.diagnosedStatusStatistics.amount || 0
          this.billingMap.diagnosedStatusStatistics.stayPayAmount = res.data.diagnosedStatusStatistics.stayPayAmount || 0
          
          this.billingMap.notPayStatusStatistics.count = res.data.notPayStatusStatistics.count || 0
          this.billingMap.notPayStatusStatistics.itemCount = res.data.notPayStatusStatistics.itemCount || 0
          this.billingMap.notPayStatusStatistics.amount = res.data.notPayStatusStatistics.amount || 0
          this.billingMap.notPayStatusStatistics.stayPayAmount = res.data.notPayStatusStatistics.stayPayAmount || 0
          
          this.billingMap.payStatusStatistics.count = res.data.payStatusStatistics.count || 0
          this.billingMap.payStatusStatistics.amount = res.data.payStatusStatistics.amount || 0
          this.billingMap.payStatusStatistics.stayPayAmount = res.data.payStatusStatistics.stayPayAmount || 0
          
          this.billingMap.refundStatusStatistics.count = res.data.refundStatusStatistics.count || 0
          this.billingMap.refundStatusStatistics.amount = res.data.refundStatusStatistics.amount || 0
          this.billingMap.refundStatusStatistics.stayPayAmount = res.data.refundStatusStatistics.stayPayAmount || 0
          
          this.billingMap.closeStatusStatistics.count = res.data.closeStatusStatistics.count || 0
          this.billingMap.closeStatusStatistics.amount = res.data.closeStatusStatistics.amount || 0
          this.billingMap.closeStatusStatistics.stayPayAmount = res.data.closeStatusStatistics.stayPayAmount || 0
        }
      },
      async getBillingList () {
        this.loading = true
        this.reqNum++
        const res = await getPhysioBillingList({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`,
          status: this.statusActive,
          pageNum: this.basicMap.pageNo,
          pageSize: 10
        })
        this.afterRes()
        if (res.code === 200) {
          this.basicMap.list = res.rows
          this.basicMap.total = res.total
        }
      },
      async getBillingRank () {
        this.loading = true
        this.reqNum++
        const res = await getPhysioBillingRank({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`
        })
        this.afterRes()
        if (res.code === 200) {
          this.productRankingList = res.data
        }
      },
      async getExecuteStatistics () {
        this.loading = true
        this.reqNum++
        const res = await getPhysioExecuteStatistics({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`
        })
        this.afterRes()
        if (res.code === 200) {
          this.executeMap.reservationStatusStatistics.count = res.data.reservationStatusStatistics.count || 0
          this.executeMap.reservationStatusStatistics.itemCount = res.data.reservationStatusStatistics.itemCount || 0
          this.executeMap.reservationStatusStatistics.hasOrderCount = res.data.reservationStatusStatistics.hasOrderCount || 0
          this.executeMap.reservationStatusStatistics.notHasOrderCount = res.data.reservationStatusStatistics.notHasOrderCount || 0

          this.executeMap.notExecuteStatusStatistics.count = res.data.notExecuteStatusStatistics.count || 0
          this.executeMap.notExecuteStatusStatistics.itemCount = res.data.notExecuteStatusStatistics.itemCount || 0
          this.executeMap.notExecuteStatusStatistics.hasOrderCount = res.data.notExecuteStatusStatistics.hasOrderCount || 0
          this.executeMap.notExecuteStatusStatistics.notHasOrderCount = res.data.notExecuteStatusStatistics.notHasOrderCount || 0

          this.executeMap.executedStatusStatistics.count = res.data.executedStatusStatistics.count || 0
          this.executeMap.executedStatusStatistics.totalExecuteCount = res.data.executedStatusStatistics.totalExecuteCount || 0
          this.executeMap.executedStatusStatistics.amount = res.data.executedStatusStatistics.amount || 0
        }
      },
      async getExecuteList () { 
        this.loading = true
        this.reqNum++
        const res = await getPhysioExecuteList({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`,
          status: this.statusActive,
          pageNum: this.basicMap.pageNo,
          pageSize: 10
        })
        this.afterRes()
        if (res.code === 200) {
          this.basicMap.list = res.rows
          this.basicMap.total = res.total
        }
      },
      async getExecuteRank () {
        this.loading = true
        this.reqNum++
        const res = await getPhysioExecuteRank({
          deptId: this.deptId,
          doctorId: this.doctorId,
          startTime: this.date[0] && `${this.date[0]} 00:00:00`,
          endTime: this.date[1] && `${this.date[1]} 23:59:59`
        })
        this.afterRes()
        if (res.code === 200) {
          this.productRankingList = res.data
        }
      },
      basicTablePageNoChange (val) {
        this.basicMap.pageNo = val
        if (this.type === '1') {
          this.getBillingList()
        } else {
          this.getExecuteList()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioData {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left_radio /deep/ .el-radio-button__inner {
    padding: 0 28px;
    height: 36px;
    line-height: 34px;
  }

  .card {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }

  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card_header_icon {
    width: 26px;
    height: 26px;
  }

  .card_header_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .card_header_icon+.card_header_title {
    margin: 0 0 0 10px;
  }

  .card_header_date {
    margin: 0 0 0 8px;
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .card_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .card_header_count {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .to_more {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .to_more_text {
    font-size: 14px;
    color: #667182;
  }

  .to_more_icon {
    margin: 0 0 0 2px;
    font-size: 14px;
    color: #667182;
  }

  .custom_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .custom_table::before {
    display: none;
  }

  .custom_table /deep/ .el-table__row:last-child td {
    border-bottom: none;
  }

  .basic {
    margin: 24px 0 0 0;
    overflow-x: auto;
  }

  .basic_content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
    min-width: 1450px;
    min-height: 560px;
  }

  .basic_info {
    flex-grow: 1;
    min-width: 0;
  }

  .basic_status_list {
    display: grid;
    grid-template-columns: 1fr auto 1fr 1fr 1fr auto 1fr 1fr;
    column-gap: 16px;
    align-items: flex-start;
    width: 100%;
  }

  .status_list_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 16px 16px 0;
    height: 132px;
    background-color: #E8F4FF;
    border-radius: 8px;
    cursor: pointer;
  }

  .status_list_item.active {
    background: linear-gradient( 135deg, #39A0FF 0%, #0177E5 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,29,57,0.2);
  }

  .status_list_item.active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    font-size: 12px;
    color: #1283ED;
    transform: translate(-50%, 0);
  }

  .status_list_line {
    width: 1px;
    height: 140px;
    background-color: #E0E0E0;
  }

  .status_title {
    line-height: 24px;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }

  .status_list_item.active .status_title {
    color: #FFFFFF;
  }

  .status_info {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 12px;
    align-items: flex-start;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .status_info.column_3 {
    grid-template-columns: 1fr auto 1fr auto 1fr;
  }

  .status_info_left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .status_info_right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .status_info_line {
    margin: 34px 0 0 0;
    width: 1px;
    height: 22px;
    background-color: #E0E0E0;
  }

  .status_list_item.active .status_info_line {
    margin: 32px 0 0 0;
    height: 28px;
    background-color: rgba(219,222,226,0.5);
  }

  .status_info_title {
    line-height: 22px;
    font-size: 13px;
    color: #667182;
    white-space: nowrap;
  }

  .status_list_item.active .status_info_title {
    color: rgba(255,255,255,0.8);
  }

  .status_info_num {
    margin: 2px 0 0 0;
    line-height: 30px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .status_list_item.active .status_info_num {
    color: #FFFFFF;
  }

  .status_info_tips {
    line-height: 24px;
    text-align: right;
    font-size: 14px;
    color: #667182;
  }

  .status_list_item.active .status_info_tips {
    color: rgba(255,255,255,0.8);
  }

  .status_info_tips_num {
    margin: 0 2px;
    color: #000000;
  }

  .status_list_item.active .status_info_tips_num {
    color: #FFFFFF;
  }

  .basic_table_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0 0 0;
    width: 100%;
  }

  .basic_table_title {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .basic_table_count {
    line-height: 24px;
    font-size: 16px;
    color: #667182;
  }

  .basic_table_count_num {
    margin: 0 2px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .basic_table_section {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .basic_table_price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .basic_table_price_text {
    font-size: 14px;
    color: #1F2329;
  }

  .basic_table_price_tag {
    margin: 0 0 0 4px;
    font-size: 12px;
    color: #FE8F1F;
  }

  .basic_table_center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .basic_table_tag {
    width: 40px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #87919B;
    background-color: #F7F8F9;
  }

  .table_tag_warning {
    color: #FE8F1F;
    background-color: #FFF0E1;
  }

  .table_tag_success {
    color: #29C01B;
    background-color: #E2F8E0;
  }

  .table_tag_info {
    color: #87919B;
    background-color: #F7F8F9;
  }

  .basic_table_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .product_ranking {
    flex-shrink: 0;
    margin: 0 0 0 16px;
    width: 355px;
    height: 100%;
  }

  .ranking_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .ranking_table::before {
    display: none;
  }
 
  .ranking_table /deep/ th.el-table__cell {
    background-color: #F7F8F9;
    border-bottom: 1px solid #E0E0E0;
  }

  .ranking_table /deep/ td.el-table__cell {
    background-color: #FFFFFF;
    border-bottom: none;
  }

  .ranking_table /deep/ th.el-table__cell>.cell {
    line-height: 20px;
    font-weight: 400;
    color: #667182;
  }

  .ranking_table /deep/ td.el-table__cell>.cell {
    line-height: 20px;
    font-weight: 400;
    color: #000000;
  }

  .ranking_table_index {
    font-weight: bold;
    font-size: 16px;
    color: #8F97A4;
  }

  .ranking_table_index_1 {
    color: #F54A45;
  }

  .ranking_table_index_2 {
    color: #FE8F1F;
  }

  .ranking_table_index_3 {
    color: #FFC900;
  }

  .ranking_table_name {
    min-width: 0;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ranking_table_name.none {
    color: #8F97A4;
  }
</style>